import { ButtonBase, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { RemoveItemButton } from "web_myplann/Finances/Components/RemoveItemButton";

type Props = {
	title: string;
	subtitle: string;
	onEdit: () => void;
	onRemove: () => void;
	variant?: "primary" | "secondary";
	isLast?: boolean;
};

export const EditableAmountRow: FC<Props> = ({
	title,
	subtitle,
	onEdit,
	onRemove,
	variant = "primary",
	isLast = false,
}) => {
	const theme = useTheme();
	const isSecondary = variant === "secondary";

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={theme.spacingTokens.sm}
			pr={theme.spacingTokens.lg}
			borderBottom={isLast ? "none" : theme.colors.border.flatRowDivider}
		>
			<ButtonBase
				disableRipple
				onClick={onEdit}
				sx={{
					flex: 1,
					minWidth: 0,
					display: "flex",
					flexDirection: "column",
					alignItems: "stretch",
					textAlign: "left",
					pl: theme.spacingTokens.lg,
					py: theme.spacingTokens.md,
					"&:active": { bgcolor: theme.palette.grey[50] },
				}}
			>
				<Typography
					variant={isSecondary ? "body2" : "bodyMedium"}
					color={isSecondary ? theme.palette.grey[700] : undefined}
					overflow="hidden"
					whiteSpace="nowrap"
					textOverflow="ellipsis"
				>
					{title}
				</Typography>
				<Typography
					variant={isSecondary ? "hint" : "caption"}
					color={isSecondary ? undefined : "text.secondary"}
					tabular
				>
					{subtitle}
				</Typography>
			</ButtonBase>
			<RemoveItemButton onClick={onRemove} />
		</Stack>
	);
};
